export default __webpack_public_path__ + "static/media/anchor.1809b37e.png";